import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Suspense, lazy, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Box, LinearProgress } from '@mui/material';
import { useAppTheme } from './theme';

// Lazy load components
const Signup = lazy(() => import('./pages/Signup'));
const SignInSide = lazy(() => import('./pages/SignInSide'));
const HomePage = lazy(() => import('./pages/HomePage'));
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const SSERoom = lazy(() => import('./pages/Dashboard/Rooms/SSERoom'));

const LoadingFallback = () => (
  <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
    <LinearProgress />
  </Box>
);

function App() {
  const user = useSelector(state => state.auth?.user)
  const navigate = useNavigate();
  const theme = useAppTheme();

  useEffect(() => {
    if (user && window.location.pathname === '/login') {
      navigate('/dashboard/rooms');
    }
  }, [user, navigate]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <HomePage />
            </Suspense>
          }
        />
        <Route
          path="/login"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <SignInSide />
            </Suspense>
          }
        />
        <Route
          path="/signup"
          element={
            <Suspense fallback={<LoadingFallback />}>
              <Signup />
            </Suspense>
          }
        />

        {/* Dashboard routes (protected) */}
        {/* route for sse public link http://localhost:5173/dashboard/rooms/6eee27a8-a1a0-44d4-bf67-35d961851d55/sse */}
        <Route 
          path="/rooms/:sessionId/sse" 
          element={
            <Suspense fallback={<LoadingFallback />}>
              <SSERoom />
            </Suspense>
          } 
        />
        <Route
          path="/dashboard/*"
          element={
            user ? (
              <Suspense fallback={<LoadingFallback />}>
                <Dashboard />
              </Suspense>
            ) : (
              <Navigate to="/login" />
            )
          }
        />

        {/* Catch-all route */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
